import React from "react";

const optionsMapper = options => options.map(({ text, value }) => (
  <option key={value} value={value}>{text}</option>
));

const selectWrapper = ({ options, selected, handleSelect }) => (
  <span className="venue__offer__option-container nowrap">
    <span>{selected.text}</span>
    <select className="venue__offer__option" value={selected.value} onChange={handleSelect}>
      {optionsMapper(options)}
    </select> <i className="fa fa-caret-down"></i>
  </span>
);

const Select = (props) => {
  const { options, selected } = props;

  if (options.length === 1) {
    return (<strong>{selected.text}</strong>);
  }

  return selectWrapper(props);
};

export default Select;



// WEBPACK FOOTER //
// ./components/last_minute_deals/Select.js